<template>
  <div class="project-wrapper">
    <div class="section-title">
      <div class="left">
        <div>
          <i class="el-icon-tickets"></i>
          <span class="title-name">工程报备</span>
          <br />
          <span class="title-desc">{{ sortText }}</span>
        </div>
      </div>
      <div class="right">
        <el-button
          @click="addReport"
          size="small"
          icon="el-icon-plus"
          v-if="checkPermission(['PROJECT_USER', 'PROJECT_ADMIN'])"
          >新增</el-button
        >
        <el-button
          @click="reportDrawer = true"
          v-if="checkPermission(['PROJECT_QUICK_VIEW_OBSERVER'])"
          size="small"
          icon="el-icon-search"
          >查重</el-button
        >
      </div>
    </div>
    <!-- 筛选模块 -->
    <div class="table-tool-box hidden-sm-and-down">
      <!-- 员工才可以显示 -->
      <div class="tool-item" v-if="checkPermission(['EMPLOYEE'])">
        <span class="tool-label">申请单位:</span>
        <span class="tool-content">
          <el-select
            v-model="tableFilters.clientName"
            style="width: 100%"
            filterable
            clearable
            placeholder="申请单位"
            @change="clientNameChange"
          >
            <template v-for="(item, index) in clientNames">
              <el-option
                :label="item.text"
                :value="item.value"
                :key="index"
              ></el-option>
            </template>
          </el-select>
        </span>
      </div>

      <div class="tool-item">
        <span class="tool-label">项目名称:</span>
        <span class="tool-content">
          <el-input
            v-model="projectNameFilter"
            placeholder="请输入项目名称"
            clearable
          ></el-input>
        </span>
      </div>

      <div class="tool-item">
        <span class="tool-label">项目状态:</span>
        <span class="tool-content">
          <el-select
            v-model="tableFilters.projectStatus"
            style="width: 100%"
            filterable
            clearable
            placeholder="项目状态"
            @change="projectStatusChange"
          >
            <template v-for="(item, index) in projectStatus">
              <el-option
                :label="item.text"
                :value="item.value"
                :key="index"
              ></el-option>
            </template>
          </el-select>
        </span>
      </div>

      <div class="tool-item" style="flex: 2">
        <div class="tool-label">时间起始:</div>
        <div class="tool-content">
          <el-date-picker
            style="width: 100%"
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </div>
      </div>
      <div class="table-search" v-if="false" @click="filterSearch">搜索</div>
    </div>
    <div class="project-table-wrapper comon-table-style">
      <el-table
        v-loading="tableLoading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        :data="tableData"
        :default-sort="{ prop: sortedBy, order: listDirection }"
        @sort-change="onTableSortChange"
        border
        class="project-table"
        style="width: 100%"
      >
        <!-- <el-table-column
              prop="applicantName"
              label="报备时间"
              align="center"
              width="100">
              <template slot-scope="scope">
                <span>{{scope.row.applyDatetime | date}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="applicantName"
              label="申请人"
              align="center">
        </el-table-column>-->
        <el-table-column
          prop="id"
          label="项目编号"
          align="center"
          sortable="custom"
        >
          <template slot-scope="scope">
            <span class="text-split" :title="scope.row.id">{{
              scope.row.id
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="clientName"
          label="申请单位"
          align="center"
          sortable="custom"
        >
          <template slot-scope="scope">
            <span class="text-split" :title="scope.row.clientName">{{
              scope.row.clientName
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="projectName"
          label="项目名称"
          align="center"
          sortable="custom"
        >
          <template slot-scope="scope">
            <span class="text-split" :title="scope.row.projectName">{{
              scope.row.projectName
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="projectType"
          align="center"
          label="单据类型"
          sortable="custom"
        >
          <template slot-scope="scope">
            <span
              class="text-split"
              :title="scope.row.projectType.replace(/工程报备/g, '')"
              >{{ scope.row.projectType.replace(/工程报备/g, "") }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="projectArea"
          align="center"
          label="项目区域"
          sortable="custom"
        >
          <template slot-scope="scope">
            <span class="text-split" :title="scope.row.projectArea">{{
              scope.row.projectArea
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="projectStatus"
          align="center"
          label="项目状态"
          sortable="custom"
        >
          <template slot-scope="scope">
            <span class="text-split" :title="scope.row.projectStatus">
              <span
                class="text-primary text-split"
                v-if="scope.row.projectStatus === '未审核'"
                >{{ scope.row.projectStatus }}</span
              >
              <span
                class="text-success text-split"
                v-if="scope.row.projectStatus === '已审核'"
                >{{ scope.row.projectStatus }}</span
              >
              <span
                class="text-wraning text-split"
                v-if="scope.row.projectStatus === '未通过'"
                >{{ scope.row.projectStatus }}</span
              >
              <span
                class="text-danger text-split"
                v-if="scope.row.projectStatus === '无效'"
                >{{ scope.row.projectStatus }}</span
              >
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="control"
          align="center"
          fixed="right"
          label="操作"
          width="120"
        >
          <template slot-scope="scope">
            <el-button
              type="warning"
              class="control-btn"
              size="small"
              @click="showProjectDetail(scope.row)"
              >查看详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagenation-wrapper">
        <!-- pc端显示 -->
        <el-pagination
          class="pagenation"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSizes"
        ></el-pagination>
      </div>
    </div>
    <!-- 右侧抽屉 -->
    <el-drawer
      title="报备单查重"
      :visible.sync="reportDrawer"
      size="60%"
      direction="rtl"
    >
      <div class="drawer-content-body">
        <el-scrollbar style="width: 100%; height: 100%; overflow-x: hidden">
          <quickView
            style="padding-right: 10px"
            @closeDrawer="reportDrawer = false"
          />
        </el-scrollbar>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import rightDraw from "@/layout/components/rightDraw";
import quickView from "@/views/report/components/quickView";
import { mapMutations } from "vuex";
import { throttle } from "@/utils/app";
import qs from "qs";
import { checkAuth } from "@/mixins";
import { checkPermission } from "@/utils/auth";
import { getOrderNameCn, getOrderType } from "@/utils/app";
export default {
  name: "project",
  mixins: [checkAuth],
  components: {
    rightDraw,
    quickView,
  },
  data() {
    return {
      reportDrawer: false,
      tableLoading: false,
      size: 10,
      page: 0,
      totalPages: 0,
      totalSizes: 0,
      tableData: [],
      clientNames: [],
      projectStatus: [],
      projectNameFilter: "",
      sortedBy: null,
      sortText: `按照默认 创建时间 倒序排序`,
      listDirection: "descending",
      tableFilters: {
        clientName: "",
        projectStatus: "",
      },
      dateRange: null,
    };
  },
  computed: {
    isRightToolBar() {
      return this.$store.state.app.rightToolBar;
    },
    isMobile() {
      return this.$store.state.app.isMobileMode;
    },
  },
  watch: {
    dateRange(val) {
      this.page = 0;
      this.getTableData();
      this.getfilterOptions();
    },
    projectNameFilter(val) {
      // 函数节流
      throttle(() => {
        this.page = 0;
        this.getTableData();
        this.getfilterOptions();
      }, 500)();
    },
  },
  created() {
    this.getTableData();
    this.getfilterOptions();
  },
  methods: {
    getOrderNameCn,
    getOrderType,
    checkPermission,
    ...mapMutations({
      ToggleMobileSideBar: "app/ToggleMobileSideBar",
      ToggleToolBar: "app/ToggleToolBar",
      CloseMobileSideBar: "app/CloseMobileSideBar",
      CloseToolBar: "app/CloseToolBar",
    }),
    filterOptionParam() {
      return {
        size: this.size,
        page: this.page,
        sort: this.sortedBy,
        clientName: this.tableFilters.clientName,
        projectStatus: this.tableFilters.projectStatus,
        projectName: this.projectNameFilter,
      };
    },
    // 获取分类列表
    getfilterOptions() {
      this.$api
        .get(`/projects/filters?${qs.stringify(this.filterOptionParam())}`)
        .then((res) => {
          if (res.status === 200 || res.status === 206) {
            let tampClientNames = [];
            let tampProjectStatus = [];
            res.data.clientNames.forEach((item) => {
              tampClientNames.push({
                text: item,
                value: item,
              });
            });
            res.data.projectStatus.forEach((item) => {
              tampProjectStatus.push({
                text: item,
                value: item,
              });
            });
            this.clientNames = tampClientNames;
            this.projectStatus = tampProjectStatus;
          }
        });
    },
    getTableData() {
      this.tableLoading = true;
      let startDate =
        this.dateRange !== null
          ? new Date(this.dateRange[0]).toISOString()
          : "";
      let endDate =
        this.dateRange !== null
          ? new Date(this.dateRange[1]).toISOString()
          : "";
      this.$api
        .get(
          `/projects?applyDatetime=${startDate}&applyDatetime=${endDate}&${qs.stringify(
            this.filterOptionParam()
          )}`
        )
        .then((res) => {
          if (res.status === 200 || res.status === 206) {
            this.tableData = res.data.content;
            this.totalPages = res.data.totalPages;
            this.totalSizes = res.data.totalElements;
            this.tableLoading = false;
          }
        })
        .catch((err) => {
          console.error("数据获取失败", err.response);
        });
    },
    getSortName(prop) {
      let group = [
        {
          key: "id",
          name: "项目编号",
        },
        {
          key: "clientName",
          name: "申请单位",
        },
        {
          key: "projectName",
          name: "项目名称",
        },
        {
          key: "projectType",
          name: "单据类型",
        },
        {
          key: "projectArea",
          name: "项目区域",
        },
        {
          key: "projectStatus",
          name: "项目状态",
        },
      ];
      return group.find((item) => item.key == prop).name;
    },
    onTableSortChange({ column, prop, order }) {
      this.listDirection = order;
      if (order === null) {
        this.sortedBy = null;
        this.sortText = `按照默认 创建时间 倒序排序`;
      } else {
        this.sortedBy = `${prop},${getOrderType(order)}`;
        this.sortText = `按照 ${this.getSortName(prop)} ${this.getOrderNameCn(
          order
        )} 排序`;
      }
      this.reFresh();
    },
    reFresh() {
      this.page = 0;
      this.getTableData();
    },
    handleSizeChange(size) {
      this.page = 0;
      this.size = size ? size : this.size;
      this.getTableData();
    },
    handleCurrentChange(Cpage) {
      this.page = Cpage ? Cpage - 1 : 0;
      this.getTableData();
    },
    clientNameChange(val) {
      this.page = 0;
      this.tableFilters.clientName = val ? val : "";
      this.getTableData();
      this.getfilterOptions();
    },
    projectStatusChange(val) {
      this.page = 0;
      this.tableFilters.projectStatus = val ? val : "";
      this.getTableData();
      this.getfilterOptions();
    },
    filterSearch() {
      // 移动端模式下需要关闭侧边栏
      this.getTableData();
      if (this.isMobile) {
        this.CloseToolBar();
      }
    },
    showProjectDetail(item) {
      this.$router.push({
        path: "/report/show",
        query: {
          model: "show",
          id: item.id,
        },
      });
    },
    addReport(item) {
      this.$router.push({
        path: "/report/add",
        query: {
          model: "add",
          id: "",
        },
      });
    },
    editProject(item) {
      this.$router.push({
        path: "/report/add",
        query: {
          model: "edit",
          id: item.id,
        },
      });
    },
    onSerch() {},
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/custom-variables.scss";
.project-wrapper {
  .limit-winth {
    width: 100%;
    font-size: 14px;
    height: 18px;
    line-height: 18px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .project-table-wrapper {
    width: 100%;
    padding-top: 30px;
    .project-table {
      border: 1px solid #dbdbdb;
      text-align: right;
      .control-btn {
        color: #333;
        background-color: $theme_color;
        border-color: $theme_color;
        margin: 5px;
      }
      .edit-btn {
        color: #333;
        background-color: transparent;
        border-color: #333;
        margin: 5px;
      }
    }
  }
  .pagenation-wrapper {
    box-sizing: border-box;
    width: 100%;
    height: 50px;
    line-height: 55px;
    text-align: left;
    background-color: transparent;
    padding: 0px 5px 0 5px;
    overflow: hidden;
    border: 1px solid #dbdbdb;
    border-top: none;
    .pagenation {
      padding: 0;
      margin-top: 10px;
    }
    .pagenation-samll {
      text-align: center;
    }
  }
  .section-title {
    width: 100%;
    padding: 19px 0 26px 0;
    border-bottom: 1px solid #e0e0e0;
    text-align: left;
    font-size: 24px;
    display: flex;
    justify-content: space-between;
    .left {
      flex: 1;
      text-align: left;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .right {
      flex: auto;
      text-align: right;
    }
    .title-name {
      font-size: 24px;
      color: #4a4a4a;
      font-weight: bold;
      margin-left: 8px;
    }
    .title-desc {
      font-size: 14px;
      color: #989898;
    }
  }
  .table-tool-box {
    box-sizing: border-box;
    position: relative;
    // padding: 0 60px 0 0;
    margin-top: 30px;
    margin-bottom: 0;
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    .tool-item {
      box-sizing: border-box;
      padding: 0 10px 0 0;
      flex: 1;
      display: flex;
      text-align: left;
      line-height: 40px;
      box-sizing: border-box;
      font-size: 0;
      &:last-child {
        padding: 0;
      }
      .tool-label {
        flex: 60px 0 0;
        width: 60px;
        text-align: left;
        font-size: 14px;
        font-weight: 450;
        color: #333;
        margin-right: 8px;
      }
      .tool-content {
        flex: 1;
        font-size: 14px;
        color: #333;
      }
    }
    .table-search {
      position: absolute;
      right: 0;
      bottom: 2px;
      width: 50px;
      height: 35px;
      line-height: 35px;
      font-size: 14px;
      text-align: center;
      color: #242424;
      border: 1px solid #929292;
      display: inline-block;
      transition: all 0.3s linear;
      &:hover {
        background-color: $theme_color;
        border: 1px solid $theme_color;
        color: #242424;
        cursor: pointer;
      }
    }
  }
}
.drawer-content-body {
  min-width: 670px;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
  position: absolute;
  padding: 0 20px;
  top: 77px;
  left: 0;
  right: 0;
  bottom: 0;
}
@media screen and(max-width:992px) {
  .project-wrapper {
    padding: 0px 0px 20px 0px;
    .right {
      .project-table-wrapper {
        padding: 0;
      }
    }
    .table-tool-box {
      display: block;
      .tool-item {
        width: 100%;
        padding: 10px 0;
        .tool-label {
          display: block;
          margin-bottom: 5px;
          color: #fff;
          text-align: left;
        }
        .tool-content {
          display: block;
          font-size: 14px;
          color: #333;
          .el-select {
            width: 100%;
          }
        }
      }
      .table-search {
        width: 100%;
        height: 45px;
        line-height: 45px;
        font-size: 15px;
        text-align: center;
        color: #333;
        background-color: $theme_color;
        display: block;
        margin-top: 12px;
        transition: all 0.3s linear;
      }
    }
  }
}
</style>
<style lang="scss">
.project-wrapper {
  .table-tool-box {
    .el-input__inner {
      border: none;
      border-radius: 0px;
    }
  }
  .pagenation-wrapper {
    // 页码列表的前后的按钮
    .el-pagination button {
      background-color: transparent;
    }
    .el-pagination button:disabled {
      background-color: transparent;
    }
    .el-pagination button:hover {
      color: #fff;
      background-color: #4c4948;
    }
    // 可选的页码列表
    .el-pager li {
      background-color: transparent;
    }
    .el-pager li:hover {
      color: #fff;
      background-color: #4c4948;
    }
    .el-pager li.active {
      color: #fff;
      background-color: #4c4948;
      cursor: default;
    }
    // 手动输入页数的输入框
    .el-pagination__editor.el-input .el-input__inner {
      background-color: transparent;
    }
    // 选择多少条每页的按钮
    .el-pagination .el-select .el-input .el-input__inner {
      background-color: transparent;
    }
  }
}
.drawer-content-body {
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }
}
</style>



